export enum PERSISTENT_TABLE_IDS {
  SALES_BY_PARENT = "salesByParent",
  SALES_BY_PRODUCT = "salesByProduct",
  PROFITABILITY_PRODUCT = "profitabilityProduct",
  MARKETING_CAMPAIGNS = "marketingCampaigns",
  MARKETING_PRODUCT_ADS = "marketingProductAds",
  FBA_INVENTORY = "fbaInventory",
}
